class ProductCardSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
    this.initImageLoading();
  }

  initImageLoading() {
    const images = this.querySelectorAll('img');
    images.forEach(img => {
      const wrapper = img.closest('.product-card__image-wrapper');
      if (!wrapper) return;

      const onLoaded = () => {
        wrapper.classList.add('is-loaded');
      };

      if (img.complete) {
        onLoaded();
      } else {
        img.addEventListener('load', onLoaded);
        img.addEventListener('error', onLoaded);
      }
    });
  }

  initSwiper() {
    const container = this.querySelector('.swiper');
    if (!container) return;

    // Check if we have more than 1 slide
    const slides = container.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    this.swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'slide',
      speed: 500,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}

if (!customElements.get('product-card-slider')) {
  customElements.define('product-card-slider', ProductCardSlider);
}
